<template>
  <div class="logged-in-shell relative" :class="{ 'manage-products-shell': $route.name === 'manage-products' }" @mousedown="trackClick">
    <div v-if="appStore.state.activeUser.length <= 0"></div>
    <div
      class="w-full relative"
      v-else-if="appStore.state.activeUser.role != 'temp'"
    >
      <div class="w-full flex relative">
        <nav @click="closeNav()" ref="nav" class="nav w-1/4 hidden xl:block">
          <div id=""></div>
          <!--- nav for desktop-->

          <ul class="nav-list cursor-pointer flex-1 w-full sticky top-0">
            <li>
              <router-link to="/home" class="nav-link" aria-label="Home" data-label="Home">
                <span class="material-symbols-outlined" aria-hidden="true">home</span>
                <span class="nav-label">Home</span>
              </router-link>
            </li>
            <li>
              <router-link to="my-profile" class="nav-link" aria-label="My Profile" data-label="My Profile">
                <span class="material-symbols-outlined" aria-hidden="true">person</span>
                <span class="nav-label">My Profile</span>
              </router-link>
            </li>
            <li>
              <router-link to="manage-products" class="nav-link" aria-label="Manage Products" data-label="Manage Products">
                <span class="nav-puck-icon" aria-hidden="true">
                  <svg viewBox="0 0 32 34" focusable="false">
                    <path class="nav-puck-shell" d="M16 1.5c3.7 0 6.9 1 8.9 2.6.9.7 1.2 3.8 1.6 5.7.3 1.3.9 1.9 1.8 2.2 1.4.4 2.4.1 3 1.4.8 1.7.2 6.8-1.8 10.7-1.5 2.9-3.7 5.7-6.1 7.3-2 1.3-4.2.4-5.3-.3-.7-.4-1.5-.5-2.1-.5s-1.4.1-2.1.5c-1.1.7-3.3 1.6-5.3.3-2.4-1.6-4.6-4.4-6.1-7.3-2-3.9-2.6-9-1.8-10.7.6-1.3 1.6-1 3-1.4.9-.3 1.5-.9 1.8-2.2.4-1.9.7-5 1.6-5.7 2-1.6 5.2-2.6 8.9-2.6Z" />
                    <g class="nav-puck-wells">
                      <circle cx="12" cy="8.2" r="2.35" />
                      <circle cx="20" cy="8.2" r="2.35" />
                      <circle cx="8.3" cy="14.5" r="2.35" />
                      <circle cx="16" cy="14.5" r="2.35" />
                      <circle cx="23.7" cy="14.5" r="2.35" />
                      <circle cx="5.5" cy="21.1" r="2.35" />
                      <circle cx="12.5" cy="21.1" r="2.35" />
                      <circle cx="19.5" cy="21.1" r="2.35" />
                      <circle cx="26.5" cy="21.1" r="2.35" />
                      <circle cx="8.3" cy="27.4" r="2.35" />
                      <circle cx="16" cy="27.4" r="2.35" />
                      <circle cx="23.7" cy="27.4" r="2.35" />
                    </g>
                  </svg>
                </span>
                <span class="nav-label">Manage Products</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="shared-products" class="nav-link" aria-label="Shared Products" data-label="Shared Products">
                <span class="material-symbols-outlined" aria-hidden="true">share</span>
                <span class="nav-label">Shared Products</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="transport-racks" class="nav-link" aria-label="Transport Racks" data-label="Transport Racks">
                <span class="material-symbols-outlined" aria-hidden="true">local_shipping</span>
                <span class="nav-label">Transport Racks</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="group-admin-page" class="nav-link" aria-label="Group Admin Page" data-label="Group Admin Page">
                <span class="material-symbols-outlined" aria-hidden="true">admin_panel_settings</span>
                <span class="nav-label">Group Admin Page</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="project-manager" class="nav-link" aria-label="Project Manager" data-label="Project Manager">
                <span class="material-symbols-outlined" aria-hidden="true">assignment</span>
                <span class="nav-label">Project Manager</span>
              </router-link>
            </li>
            <li>
              <router-link to="team-members" class="nav-link" aria-label="Team Members" data-label="Team Members">
                <span class="material-symbols-outlined" aria-hidden="true">groups</span>
                <span class="nav-label">Team Members</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="analytics" class="nav-link" aria-label="Analytics" data-label="Analytics">
                <span class="material-symbols-outlined" aria-hidden="true">monitoring</span>
                <span class="nav-label">Analytics</span>
              </router-link>
            </li>
            <li>
              <router-link to="archives" class="nav-link" aria-label="Grid Explorer" data-label="Grid Explorer">
                <span class="material-symbols-outlined" aria-hidden="true">grid_view</span>
                <span class="nav-label">Grid Explorer</span>
              </router-link>
            </li>
            <li v-if="appStore.state.activeUser?.role == 'lab-admin'">
              <router-link to="data-settings" class="nav-link" aria-label="Data Settings" data-label="Data Settings">
                <span class="material-symbols-outlined" aria-hidden="true">database</span>
                <span class="nav-label">Data Settings</span>
              </router-link>
            </li>
            <li>
              <router-link to="/customer-support" class="nav-link" aria-label="Customer Support" data-label="Customer Support">
                <span class="material-symbols-outlined" aria-hidden="true">support_agent</span>
                <span class="nav-label">Customer Support</span>
              </router-link>
            </li>
            <li v-if="appStore.state.isMark">
              <router-link to="admin" class="nav-link" aria-label="Administrative" data-label="Administrative">
                <span class="material-symbols-outlined" aria-hidden="true">settings</span>
                <span class="nav-label">Administrative</span>
              </router-link>
            </li>
          </ul>
        </nav>
        <div
          @click="closeNav()"
          style="z-index: 9000; padding-top: 10vh"
          ref="taptoclose"
          class="absolute w-full top-0 text-3xl right-0 hidden bg-black/75 h-screen text-white cursor-pointer"
        >
          <div class="absolute right-0 flex justify-center">Tap to Close</div>
        </div>
        <main>
          <div v-if="$route.name !== 'manage-products'" ref="toprowid" id="toprow">
            <LoggedInHeader @switch-lab="switchLab" />
          </div>
          <div class="flex-1 justify-center w-full">
            <router-view
              :change-page="setPage"
              @openfeedback="showFeedback = true"
            ></router-view>
            <!-- <component :change-page="changeSelectedPage" :is="selectedPage" /> -->
          </div>
          <div
            class="bg-sky-900 invisible z-10 text-white text-center text-sm py-3 relative bottom-0 w-full mt-8"
          >
            inventory.subangstrom.com - All Rights Reserved
            <!--space holder-->
          </div>
          <div
            class="bg-sky-900 z-20 text-white text-center text-sm py-3 absolute bottom-0 left-0 w-full mt-8"
          >
            inventory.subangstrom.com - All Rights Reserved
            <div class="absolute bottom-0 right-0 text-xs text-gray-400 mr-2">
              {{ "v" + $version }}
            </div>
          </div>
        </main>
        <TeamChatDock />
      </div>
    </div>
    <div class="w-screen h-screen flex items-center justify-center" v-else>
      <div class="inline-block m-auto">
        Your account is awaiting approval from your lab's administrator. You
        will receive an email notification once approved.
      </div>
    </div>

    <display-modal v-if="showFeedback" @ridfeedback="ridFeedback">
      <feedback-inner></feedback-inner>
    </display-modal>
  </div>
</template>

<script>
import FeedbackInner from "./modal-inners/feedback-inner.vue";
import LoggedInHeader from "./ui/LoggedInHeader.vue";
import TeamChatDock from "./team-chat/TeamChatDock.vue";
// import ManageProducts from './router-pages/loggedin/ManageProducts.vue';
// import MyProfile from './router-pages/loggedin/MyProfile.vue';
// import Messages from './router-pages/loggedin/Messages.vue';
// import SharedProducts from './router-pages/loggedin/SharedProducts.vue';
// import TeamMembers from './router-pages/loggedin/TeamMembers.vue';
// import ProjectManager from './router-pages/loggedin/ProjectManager.vue';
// import TransportRacks from './router-pages/loggedin/TransportRacks.vue';
// import GroupAdminPage from './router-pages/loggedin/GroupAdminPage.vue';
import { ref, provide, onMounted, watch, computed } from "vue";
import { useRouter } from "vue-router";
import store from "../store/index.js";

export default {
  components: { FeedbackInner, LoggedInHeader, TeamChatDock },
  props: [],

  methods: {
    switchLab(value) {
      const selectedLabId = typeof value === "string" ? value : value?.target?.value;
      if (!selectedLabId) return;
      const url =
        this.appStore.state.hostname + "/api/v1/users/switchlab/" + selectedLabId;
      const request = new Request(url, {
        credentials: "include",
        method: "GET",
      });
      fetch(request)
        .then((resp) => resp.json())
        .then((data) => {
          if (data.status == "fail") throw new Error(data.message);
          else {
            window.location.reload();
            // console.log(data.data.data);
            //context.commit("updateUserData", { value: data.data.data });
            //arrayOfDewars.value = data.data.data;
          }
        })
        .catch((err) => console.log(err));
    },
    trackClick(ev) {
      console.log("mouse down on", ev.target, this.$route);
      if (
        (this.$route.name == "home" || this.$route.name == "manage-products") &&
        !this.appStore.state.importModalMounted
      ) {
        if (
          ev.target instanceof HTMLInputElement ||
          ev.target instanceof HTMLTextAreaElement ||
          ev.target instanceof HTMLSelectElement
        )
          console.log("input clicked");
        else
          window.setTimeout(() => {
            if (document.getElementById("searchbarforloggedin"))
              document.getElementById("searchbarforloggedin").focus();
          }, 100);
      }
    },
  },

  setup() {
    const boxColors = store.state.boxColors;
    const transformBoxColor = store.state.transformBoxColor;
    const selectedPage = ref("home");
    const nav = ref(null);
    const toprowid = ref(null);
    const changelog = ref(null);
    const taptoclose = ref(null);
    const router = useRouter();
    const showFeedback = ref(false);
    const feedbackElem = ref(null);
    const userEmail = computed(() => {
      return store.state.activeUser?.email;
    });

    watch(userEmail, (newVal) => {
      if (newVal) {
        // Assuming you might need a delay, use setTimeout here
        setTimeout(() => {
          searchheightfix();
        }, 500); // Adjust the delay as needed
      }
    });
    const topRowHeight = ref("0px");
    provide("topRowHeight", topRowHeight);

    function searchheightfix() {
      const stupidinterval = setTimeout(() => {
        if (changelog.value) changelog.value.classList.add("giveheight");

        function outerHeight(el) {
          var height = el.offsetHeight;
          var style = getComputedStyle(el);

          height += parseInt(style.marginTop) + parseInt(style.marginBottom);
          return height;
        }

        if (toprowid.value) {
          console.log(outerHeight(toprowid.value) + "px");
          topRowHeight.value = outerHeight(toprowid.value) + "px";
          // console.log((toprowheight.value = this.topRowHeight.value));
          clearTimeout(stupidinterval);
        }
      }, 500);
    }

    // function changeSelectedPage(pageName) {
    //   selectedPage.value = pageName;
    // }

    function setPage(pagename) {
      router.push({ name: pagename });
      // if (window.innerWidth < 1280) {
      //   nav.value.style.transform = "translateX(-100%)";
      // }
    }

    function ridFeedback() {
      showFeedback.value = false;
    }

    function closeNav() {
      if (window.innerWidth >= 1280) {
        taptoclose.value.style.display = "none";
        return;
      }

      if (window.innerWidth < 1280) {
        nav.value.classList.remove("nav-mobile-open");
        nav.value.style.transform = "translateX(-100%)";
      }

      taptoclose.value.style.display = "none";
      taptoclose.value.style.left = "";
      taptoclose.value.style.width = "";
      nav.value.style.display = "none";
      nav.value.style.width = "";
      nav.value.style.maxWidth = "";
    }

    function handleResize() {
      searchheightfix();
      if (window.innerWidth >= 1280 && nav.value) {
        nav.value.style.display = "";
        nav.value.style.position = "";
        nav.value.style.zIndex = "";
        nav.value.style.transform = "";
        nav.value.style.transition = "";
        nav.value.style.width = "";
        nav.value.style.maxWidth = "";
        nav.value.classList.remove("nav-mobile-open");
        if (taptoclose.value) {
          taptoclose.value.style.display = "none";
          taptoclose.value.style.left = "";
          taptoclose.value.style.width = "";
        }
      }
    }

    onMounted(() => {
      searchheightfix();
      window.addEventListener("resize", handleResize);
      addCssForBoxColors();
    });

    function addCssForBoxColors() {
      if (!document.getElementById("singletonBoxColors")) {
        const styleElem = document.createElement("style");
        document.head.append(styleElem);
        let css = "";
        styleElem.id = "singletonBoxColors";
        styleElem.type = "text/css";

        boxColors.forEach((color, index) => {
          if (color == "white") {
            css += `.graycircle-${index} {fill: ${transformBoxColor(
              "white",
              true
            )};}`;

            css += `.boxChoice-color-${index}.clip .st0 {
                                       stroke:${transformBoxColor(
                                         color,
                                         true
                                       )};}`;

            css += `.boxChoice-color-${index} .st2 {stroke:${transformBoxColor(
              color,
              true
            )};}`;
          } else {
            css += `.graycircle-${index} {

            fill: ${transformBoxColor(color)};}`;
          }

          css += `.boxChoice-color-${index}.clip .st3 {
                                  fill: none;
                                }`;

          css += `.boxChoice-color-${index}.clip .st0 {

                                 fill: ${transformBoxColor(color)} !important;
                                 }`;
          css += `.boxChoice-color-${index}.unclip .st0 {

                                                    fill: ${transformBoxColor(
                                                      color,
                                                      true
                                                    )} !important;

                         }`;
          css += `.boxChoice-color-${index}.unclip .st1 {

                                                    fill: ${transformBoxColor(
                                                      color
                                                    )} !important;

                         }`;

          css += `.boxChoice-color-${index}.clip .st1 {fill: ${transformBoxColor(
            color,
            true
          )} !important;}`;

          css += `.boxChoice-color-${index} .st2 {

                         fill: #ffffff !important;
                         }`;

          css += `.boxChoice-color-${index} .stblack {

                         fill: #000000 !important;
                         }`;
          css += `.boxChoice-color-${index}.unclip .st3 {
   fill: url(#SVGID_PLUSSIGN) !important;
                             stroke: #ffffff;
                             stroke-width: 0.25;
                             stroke-miterlimit: 10;
                         }`;
        });

        boxColors.forEach((color) => {
          if (color == "white") {
            css += `.well-white-clipped .st2 {
           stroke:${transformBoxColor(color, true)} !important;}`;
          }

          css += `.well-${color.replace(/\s+/g, "-")}-clipped .st0 {
        fill:${transformBoxColor(color)} !important;
        }
        .well-${color.replace(/\s+/g, "-")}-clipped .st1 {
        fill:${transformBoxColor(color, true)} !important;
        }

        `;
        });

        boxColors.forEach((color) => {
          if (color == "white") {
            css += `.well-white-unclipped .st2 {
           stroke:${transformBoxColor(color, true)} !important;}`;
          }
          css += `.well-${color.replace(/\s+/g, "-")}-unclipped .st0 {
        fill:${transformBoxColor(color, true)} !important;
        }
        .well-${color.replace(/\s+/g, "-")}-unclipped .st1 {
        fill:${transformBoxColor(color)} !important;
        }

        `;
        });

        if (styleElem.styleSheet) {
          // This is required for IE8 and below.
          styleElem.styleSheet.cssText = css;
        } else {
          styleElem.appendChild(document.createTextNode(css));
        }
      }
    }

    function showNav() {
      if (nav.value.style.transform != "translateX(0%)") {
        nav.value.classList.add("nav-mobile-open");
        const openNavWidth = Math.min(260, Math.floor(window.innerWidth * 0.82));
        nav.value.style.display = "block";
        nav.value.style.width = `${openNavWidth}px`;
        nav.value.style.maxWidth = `${openNavWidth}px`;
        taptoclose.value.firstElementChild.style.width =
          window.innerWidth - openNavWidth + "px";
        taptoclose.value.style.left = `${openNavWidth}px`;
        taptoclose.value.style.width = `calc(100% - ${openNavWidth}px)`;
        taptoclose.value.style.display = "block";
        nav.value.style.position = "fixed";
        nav.value.style.zIndex = "9999";
        nav.value.style.transform = "translateX(0%)";
        nav.value.style.transition = "transform .5s ease-out";
      } else {
        nav.value.classList.remove("nav-mobile-open");
        nav.value.style.transform = "translateX(-100%)";
        nav.value.style.width = "";
        nav.value.style.maxWidth = "";
        taptoclose.value.style.left = "";
        taptoclose.value.style.width = "";
      }
      /*if (nav.value.style.transform != "none") {
        nav.value.style.width = "300px";
        nav.value.style.transition = "width .5s ease-out";
      } else nav.value.style.width = "0"; */
    }
    return {
      selectedPage,
      taptoclose,
      showNav,
      nav,
      showFeedback,
      topRowHeight,
      toprowid,
      addCssForBoxColors,
      ridFeedback,
      setPage,
      changelog,
      feedbackElem,
      closeNav,
    };
  },
};
</script>
<style scoped>
.logoutbtn {
  padding: 0.1rem 0.4rem;
}

a:visited :not(.expandable) {
  color: white;
}

button {
  margin: auto;
  cursor: pointer;
  background: none rgba(51, 92, 139);
  border: 2px solid rgba(47, 83, 125);

  text-align: center;
  margin-bottom: 1rem;
  min-height: min-content;
  max-height: 39px;
  height: 6vh;
  max-width: 162px;
  width: 100%;
  color: rgb(255, 255, 255);

  font-family: Montserrat;
  border-radius: 26px;
}

#toprow {
  min-height: min-content;
  width: 100%;
}
#toprow img {
  max-height: 60px;
  width: auto;
}

.nav {
  position: relative;
  z-index: 100;
  flex: 0 0 64px;
  width: 64px;
  max-width: 64px;
  color: white;
  background: rgb(5, 46, 77);
  min-height: 100vh;
  overflow: visible;
}

.nav-list {
  margin: 0;
  padding: 0;
  list-style: none;
  overflow: visible;
}

.nav-list li {
  margin: 0;
  padding: 0;
  border: 0;
  overflow: visible;
}

.nav-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  min-height: 56px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  color: #fff;
  text-decoration: none;
  overflow: visible;
  transition: background 0.15s ease, color 0.15s ease;
}

.nav-list li:first-child .nav-link {
  border-top: 0;
}

.nav-link:hover,
.nav-link:focus-visible,
.nav-link.router-link-active {
  background: #097021;
  color: #fff;
  outline: none;
}

.nav-link:hover,
.nav-link:focus-visible {
  z-index: 1000;
}

.nav-link .material-symbols-outlined {
  font-size: 25px;
  line-height: 1;
}

.nav-label {
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  z-index: 1000;
  display: block;
  max-width: 220px;
  padding: 7px 10px;
  border-radius: 6px;
  background: #052e4d;
  box-shadow: 0 10px 24px rgb(15 23 42 / 0.22);
  color: #fff;
  font-size: 12px;
  font-weight: 800;
  line-height: 1.2;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%) translateX(-4px);
  white-space: nowrap;
  transition: opacity 120ms ease, transform 120ms ease;
}

.nav-link:hover .nav-label,
.nav-link:focus-visible .nav-label {
  opacity: 1;
  pointer-events: auto;
  transform: translateY(-50%) translateX(0);
}

.nav-puck-icon {
  display: inline-flex;
  width: 25px;
  height: 27px;
  pointer-events: none;
}

.nav-puck-icon svg {
  display: block;
  width: 100%;
  height: 100%;
}

.nav-puck-shell {
  fill: #fff;
  stroke: #9ac6df;
  stroke-width: 1.2;
}

.nav-puck-wells circle {
  fill: #fff;
  stroke: #052e4d;
  stroke-width: 1.25;
}

@media (max-width: 1279px) {
  .nav {
    width: min(260px, 82vw);
    max-width: min(260px, 82vw);
    flex-basis: min(260px, 82vw);
    overflow-y: auto;
    transform: translateX(-100%);
  }

  .nav-link {
    justify-content: flex-start;
    gap: 0.75rem;
    width: 100%;
    min-height: 48px;
    padding: 0 1rem;
  }

  .nav-label {
    position: static;
    opacity: 1;
    transform: none;
    max-width: none;
    padding: 0;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    font-size: 0.9rem;
    pointer-events: auto;
    white-space: normal;
  }
}

.nav.nav-mobile-open {
  flex-basis: min(260px, 82vw) !important;
  width: min(260px, 82vw) !important;
  max-width: min(260px, 82vw) !important;
  overflow-y: auto !important;
}

.nav.nav-mobile-open .nav-list {
  width: 100% !important;
}

.nav.nav-mobile-open .nav-link {
  justify-content: flex-start !important;
  gap: 12px !important;
  width: 100% !important;
  min-height: 54px !important;
  padding: 0 16px !important;
}

.nav.nav-mobile-open .nav-label {
  position: static !important;
  z-index: auto !important;
  max-width: none !important;
  padding: 0 !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  transform: none !important;
  transition: none !important;
}

.nav.nav-mobile-open .nav-link:hover .nav-label,
.nav.nav-mobile-open .nav-link:focus-visible .nav-label {
  transform: none;
}

button {
  border-radius: 0;
  min-height: 0;
  height: auto;
}

main {
  background: #fff;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;

  align-items: flex-start;
  position: relative;
  top: 0;
  left: 0;
}

.logged-in-shell {
  min-height: 100vh;
  background: #fff;
}

.manage-products-shell main {
  flex: 1 1 auto;
  max-width: none;
  min-width: 0;
  margin: 0;
  align-items: stretch;
}

.manage-products-shell .nav {
  display: block;
  flex: 0 0 64px;
  width: 64px;
  max-width: 64px;
  overflow: visible;
  transform: none;
}

.manage-products-shell .nav-link {
  justify-content: center;
  gap: 0;
  width: 64px;
  min-height: 56px;
  padding: 0;
}

.manage-products-shell .nav-label {
  position: absolute;
  left: calc(100% + 8px);
  top: 50%;
  z-index: 1000;
  max-width: 220px;
  padding: 0.35rem 0.55rem;
  border-radius: 4px;
  background: rgba(5, 46, 77, 0.96);
  box-shadow: 0 8px 18px rgba(4, 20, 35, 0.2);
  font-size: 0.75rem;
  line-height: 1.2;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-50%) translateX(-4px);
  white-space: nowrap;
}

.manage-products-shell .nav-link:hover .nav-label,
.manage-products-shell .nav-link:focus-visible .nav-label {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

.manage-products-shell .manage-products-menu-toggle {
  display: none;
}

.manage-products-shell main > .bg-sky-900 {
  display: none;
}

.manage-products-shell #toprow {
  min-height: 56px;
  border-bottom: 1px solid #d8e0ea;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.manage-products-shell #toprow img {
  max-height: 42px;
}
</style>
